export const gtagSendEvent = (target) => {
  
  if (target && target.livemode > 0) {

    // 1. Push info. into the data layer
    if (typeof window !== 'undefined') { // Check if window is available

      // Check if the dataLayer variable already exists in the global window object. If it doesn't, initialize dataLayer as an empty array
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push(
        {
          "event": target.eventName,
	  "transactionId": target.sessionId,
          "purchaseValue": target.purchasePaid,
	  "customerEmail": target.customerEmail // Unhashed
        }
      );

    }
    else {
      console.warn("window is not available");
    }
  }
};
